import { withActiveToken } from "./auth";
import { getAPIURL } from "./utils";
import { fetchProtected } from "./utils";
import { revealAppPassword, rotateAppPassword } from "./app-password";

export const getDomains = async (callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("GET", `businesses/${activeBusiness.uuid}/domains/`)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

export const createDomain = async (domain, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("POST", `businesses/${activeBusiness.uuid}/domains/`, domain)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

export const updateDomain = async (domainId, domain, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("PATCH", `businesses/${activeBusiness.uuid}/domains/${domainId}/`, domain)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json, res.status);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

export const isDomainRegistered = async (domainId, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("GET", `businesses/${activeBusiness.uuid}/domains/${domainId}/registrations/`)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

export const generateDkim = async (domainId, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("POST", `businesses/${activeBusiness.uuid}/domains/${domainId}/dkims/`)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}
export const getDomainDkim = async (domainId, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("GET", `businesses/${activeBusiness.uuid}/domains/${domainId}/dkims/`)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);


}
export const domainRecordsVerification = async (domainId, subdomain, record_type, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("GET", `businesses/${activeBusiness.uuid}/domains/${domainId}/records/?subdomain=${subdomain ? subdomain : ''}&type=${record_type}`)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

export const createEmail = async (domainId, email, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("POST", `businesses/${activeBusiness.uuid}/domains/${domainId}/emails/`, email)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

export const fetchDomainEmails = async (domainId, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        fetchProtected("GET", `businesses/${activeBusiness.uuid}/domains/${domainId}/emails/`)
            .then((res) => {
                if (res.ok) {
                    return res.json().then((json) => {
                        callback?.(json);
                    });
                }
                return res.json().then((json) => {
                    onError?.(json);
                    return Promise.reject(json);
                });
            });
    }, router);
}

// The app password: shown without replacing it, or replaced on purpose
// (lib/app-password.js). callback(json, {rotated}) on success, onError(json,
// {needsNewPassword}) on a refusal or no answer.
const appPassword = (action, domainId, emailId, callback, onError, activeBusiness, router) => {
    withActiveToken(() => {
        const path = `businesses/${activeBusiness.uuid}/domains/${domainId}/emails/${emailId}/fdts/`;
        action((method) => fetchProtected(method, path))
            .then((result) => {
                if (result.ok) {
                    callback?.(result.body, { rotated: result.rotated });
                } else {
                    onError?.(result.body, { needsNewPassword: result.needsNewPassword });
                }
            }, () => onError?.({}, { needsNewPassword: false }));
    }, router);
}

export const revealPassword = (domainId, emailId, callback, onError, activeBusiness, router) =>
    appPassword(revealAppPassword, domainId, emailId, callback, onError, activeBusiness, router);

export const rotatePassword = (domainId, emailId, callback, onError, activeBusiness, router) =>
    appPassword(rotateAppPassword, domainId, emailId, callback, onError, activeBusiness, router);